export default __webpack_public_path__ + "static/media/website-button.c21e81ad.svg";